/** @file Z_BIAS_UNIT: depth units per zOrder step, a tie-breaker (design 15.2). */

/** 0.01 unit of depth per zOrder step; positive bias is nearer. */
export const Z_BIAS_UNIT = 0.01;
